import { IoIosSend } from "react-icons/io";
import getBookingFormattedDate from "../../Config/Booking";
import { useState } from "react";
import { SendSubscriptionNotification } from "../Modals/SendSubscriptionNotification";
import { FaWhatsapp } from "react-icons/fa";
import { useDisclosure } from "@chakra-ui/react";
import { SelectNotificationModal } from "../Modals/SelectNotificationModal";
export const SingleSubscriptionRow = ({ props }: any) => {
  const [modal, setModal] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    _id:{user_uuid},
    user_details: { first_name, last_name, email,phone },
    expert_details: { full_name },
    booking_count,
    left_bookings,
    is_active,
    first_session_date,
    latest_session_date,
    subscriptions_end_dates,
  } = props;
  const statusClass = is_active ? "active-status" : "ended-status";

  return (
    <tr>
      <td>
        {first_name} {last_name}
      </td>
      <td>{email}</td>
      <td>{full_name}</td>
      <td className={statusClass}>{is_active ? "Active" : "Ended"}</td>
      <td>
        {booking_count - left_bookings}/{booking_count}
      </td>
      <td> {getBookingFormattedDate(first_session_date)} </td>
      <td>{getBookingFormattedDate(latest_session_date)}</td>
      <td>
        {subscriptions_end_dates.map((date: any, index: any) => (
          <div key={index}>{getBookingFormattedDate(date)}</div>
        ))}
      </td>
      <td>
        <div className="d-flex justify-content-around align-items-center">
          <div>
            <span title="App notification">
              <IoIosSend  className="button-icon pointer"
                onClick={() => {
                  setModal("usermodal");
                  onOpen();
                }}
              />
            </span>
          </div>
          <div>
            <span title="Whatsapp notification">
              <FaWhatsapp className="button-icon disabledButton"
              //  onClick={() => {
              //   setModal("subscriptionnotification");
              //   onOpen();
              // }}
              />
            </span>
          </div>
        </div>
      </td>
      {modal === "usermodal" && (
        <SelectNotificationModal
          isOpen={isOpen}
          onClose={onClose}
          category={"subscription"}
          ids={[user_uuid]}
          // func={closeModal}
          // id={id}
        />
      )}
      {/* {modal === "subscriptionnotification" && (
        <SubscriptionNotification
          isOpen={isOpen}
          onClose={onClose}
          phone={"+91"+phone.slice(-10)}
          // func={closeModal}
          // id={id}
        />
      )} */}
    </tr>
  );
};
